<ng-container *ngFor="let stage of stages">
	<h4 class="mb-3">{{ !!portfolio ? portfolioService.getStageName(portfolio, stage) : ('productStages.' + stage | translate) }}</h4>
	<div class="row mb-5">
		<div class="col-12 col-md-6 mb-3" *ngFor="let contentExperiment of stageExperiments[stage]">
			<app-content-experiment-card [contentExperiment]="contentExperiment" (cardClicked)="openContentExperiment($event)"></app-content-experiment-card>
		</div>
	</div>
</ng-container>
